/**
 * URL Manager - Handles the url parameters as predefined categories.
 */

import { uncheckCategoryFilter } from './CategoriesManager'

/**
 * Handles the URL query string to determine if any categories should be hidden
 * based on the 'demo-hide' parameter. If the parameter is present, it extracts
 * the categories to hide and unchecks their corresponding filters.
 *
 * @example
 * // URL: https://performance-buildings.local/demo-page/?demo-hide=infrastructure&amenities
 * // This will uncheck filters for 'infrastructure' and 'amenities'.
 */
const HandleURL = () => {
  const queryString = window.location.search.substring(1)

  if (queryString && queryString.includes('demo-hide=')) {
    // Extract everything after 'demo-hide='.
    const hideParamString = queryString.split('demo-hide=')[1]

    // Split by '&' to get all categories to hide.
    const categoriesToHide = hideParamString.split('&')

    categoriesToHide.forEach(category => {
      uncheckCategoryFilter( category )
    })
  }
}

export default HandleURL
